"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrencyCodeByCountry = exports.eCurrency = exports.getAllCurrencyItems = exports.getCurrencyItemsByNameFromCoveredCountries = exports.getCurrencyItems = exports.getAllCurrencyItemsFromCoveredCountries = exports.getCurrencyFromName = exports.getCurrencyName = exports.getAllCurrencies = void 0;
const utils_1 = require("@loadsure/utils");
const countries_1 = require("../countries");
const currency_class_1 = __importDefault(require("./currency.class"));
const currencies_json_1 = __importDefault(require("./currencies.json"));
const allCurrencies = currencies_json_1.default.map((aData) => new currency_class_1.default(aData.code, aData.name, aData.countries));
function getAllCurrencies() {
    return allCurrencies;
}
exports.getAllCurrencies = getAllCurrencies;
function getCurrencyName(code) {
    var _a;
    return (_a = allCurrencies.find((currency) => currency.code === code)) === null || _a === void 0 ? void 0 : _a.name;
}
exports.getCurrencyName = getCurrencyName;
function getCurrencyFromName(code) {
    return getAllCurrencies().find((currency) => currency.code === code);
}
exports.getCurrencyFromName = getCurrencyFromName;
function getAllCurrencyItemsFromCoveredCountries() {
    return countries_1.getAllCoveredCountryItems().map((country) => country.value);
}
exports.getAllCurrencyItemsFromCoveredCountries = getAllCurrencyItemsFromCoveredCountries;
function getCurrencyItems(items) {
    return items.map((currencyOrCode) => {
        var _a;
        if (currencyOrCode instanceof currency_class_1.default) {
            return new utils_1.Item(currencyOrCode.code, currencyOrCode.name);
        }
        return new utils_1.Item(currencyOrCode, (_a = getCurrencyName(currencyOrCode)) !== null && _a !== void 0 ? _a : "");
    });
}
exports.getCurrencyItems = getCurrencyItems;
function getCurrencyItemsByNameFromCoveredCountries(items) {
    var _a;
    const currencies = items.map((item) => getCurrencyFromName(item));
    const coveredCountries = getAllCurrencyItemsFromCoveredCountries();
    const validCurrencies = [];
    for (const currency of currencies) {
        const isValid = currency === null || currency === void 0 ? void 0 : currency.countries.filter((country) => coveredCountries.includes(country));
        if (isValid === null || isValid === void 0 ? void 0 : isValid.length) {
            validCurrencies.push(new utils_1.Item(currency === null || currency === void 0 ? void 0 : currency.code, (_a = currency === null || currency === void 0 ? void 0 : currency.name) !== null && _a !== void 0 ? _a : ""));
        }
    }
    return validCurrencies;
}
exports.getCurrencyItemsByNameFromCoveredCountries = getCurrencyItemsByNameFromCoveredCountries;
function getAllCurrencyItems() {
    const coveredCountries = getAllCurrencyItemsFromCoveredCountries();
    const validCurrencies = getAllCurrencies().filter((currency) => currency.countries.some((country) => coveredCountries.includes(country)));
    return getCurrencyItems(validCurrencies);
}
exports.getAllCurrencyItems = getAllCurrencyItems;
var eCurrency;
(function (eCurrency) {
    eCurrency["USD"] = "USD";
    eCurrency["GBP"] = "GBP";
})(eCurrency = exports.eCurrency || (exports.eCurrency = {}));
function getCurrencyCodeByCountry(country, defaultCurrency = eCurrency.USD) {
    var _a, _b;
    return ((_b = (_a = allCurrencies.find((element) => element.countries.includes(country))) === null || _a === void 0 ? void 0 : _a.code) !== null && _b !== void 0 ? _b : defaultCurrency);
}
exports.getCurrencyCodeByCountry = getCurrencyCodeByCountry;
exports.default = currency_class_1.default;
//# sourceMappingURL=index.js.map